import { SHOW_APP_LOADER, HIDE_APP_LOADER, CURRENT_SELECTED_TAB } from "./types";

export const showAppLoaderAction = () => {
  return {
    type: SHOW_APP_LOADER,
    displayAppLoader: true
  };
};

export const hideAppLoaderAction = () => {
  return {
    type: HIDE_APP_LOADER,
    displayAppLoader: false
  };
};

export const setSelectedTab = (currentSelectedTab: string | null) => {
  return {
    type: CURRENT_SELECTED_TAB,
    currentSelectedTab
  };
}